import { makeAutoObservable, runInAction } from "mobx";
import { statusFetching } from "constants/types";
import { NormalizedError } from "services/api/errorHandler";
import { getNotificationSettings } from "services";
import { NotificationSettingsDto } from "interfaces";

export class NotificationStore {
  public settings: NotificationSettingsDto = {
    emailRequestStatusChange: false,
    emailDocumentUpload: false,
    emailContractStatusChange: false,
    uiRequestStatusChange: false,
    uiTxUpload: false,
    emailPlatformLogin: false,
    emailPasswordChange: false,
    emailNewRubOperation: false,
  };

  public fetchStatus: statusFetching = "init";
  public fetchError?: NormalizedError;

  constructor() {
    makeAutoObservable(this);
  }

  get isPending() {
    return this.fetchStatus === "fetching";
  }

  fetchNotificationSettings = async (userId: string, companyId: string) => {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    await getNotificationSettings({ userId, companyId })
      .then((res) => {
        runInAction(() => {
          this.settings = res;
          this.fetchStatus = "success";
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.fetchStatus = "error";
          this.fetchError = error;
        });
      });
  };

  updateSettingsQuietly = async (userId: string, companyId: string): Promise<NotificationSettingsDto | null> => {
    try {
      const updatedSettings = await getNotificationSettings({
        userId,
        companyId,
      });
      runInAction(() => {
        this.settings = updatedSettings;
      });
      return updatedSettings;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
}
